import { isLocalStorageAvailable, safeGetItem, safeSessionGetItem, safeSessionSetItem, safeSetItem } from './localStorage'

export type AuthAccessEvent = 'login' | 'platform_access'

const LAST_SIGN_IN_KEY_PREFIX = 'barmanager.lastSignIn'
const SESSION_ACCESS_KEY_PREFIX = 'barmanager.sessionAccess'

// `metadata.lastSignInTime` solo cambia con un sign-in real (email, Google
// popup/one-tap), no con F5, restauración de persistencia ni refresh de token.
// - Si cambió respecto a lo guardado → login real.
// - Si no cambió pero la pestaña/sesión no tenía marca → acceso con sesión ya iniciada.
// - Si ya había marca de sesión → nada (evita un insert por carga).
export const resolveAuthAccessEvent = (
  uid: string,
  lastSignInTime: string | null | undefined
): AuthAccessEvent | null => {
  if (!isLocalStorageAvailable()) return null

  const lastSignIn = lastSignInTime || ''
  const lastSignInKey = `${LAST_SIGN_IN_KEY_PREFIX}.${uid}`
  const sessionKey = `${SESSION_ACCESS_KEY_PREFIX}.${uid}`

  if (safeGetItem(lastSignInKey) !== lastSignIn) {
    safeSetItem(lastSignInKey, lastSignIn)
    safeSessionSetItem(sessionKey, '1')
    return 'login'
  }

  if (safeSessionGetItem(sessionKey) !== '1') {
    safeSessionSetItem(sessionKey, '1')
    return 'platform_access'
  }

  return null
}
